import React from 'react';
import Header from "../Header";
import Banner from '../Banner';
import Blog from '../Blog';
import Feature from '../Feature';
import HowItWorksTwo from '../how-it-works';
import Footer from '../Footer';
import ScrollToTopButton from '../../Components/Theme/Theme';
import Ensavoir from '../../Components/frontend/statut-juridique/en-savoir-area';



function Rendez_vous1() {
    return (
        <>
            <Header></Header>
            <Ensavoir></Ensavoir>
            <Footer></Footer>                      
            <ScrollToTopButton></ScrollToTopButton>                      
        </>
    );
}

export default Rendez_vous1;